import { Component, OnInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { RmdTrackerApiService } from '../../services/rmd-tracker.service';
import { ServicerService } from '../../../servicer/services/servicer.service';
import { AdvisorService } from '../../../advisor/services/advisor.service';
import { GeneralService } from '../../services/general.service';
import { AdvisoryFirmApiService } from '../../services/advisory-firm-api.service';
import { IdentityService } from '../../../identity/services/identity.service';
import { DataGridColumn, FilterCondition } from '../../models/DevExtreme/column.models';
import {
  RmdStatus, InvestorRmdStatusViewModel, AccountRmdStatusViewModel,
  RMDTrackingInvestorLevelViewModel, RMDAccountLevelViewModel, NoteViewModel
} from '../../models/rmd.models';
import { DxDataGridComponent } from 'devextreme-angular';
import { IUser } from '../../models/identity.models';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { exportDataGrid } from "devextreme/excel_exporter";
import * as FileSaver from 'file-saver';
import { RmdCalculatorComponent } from '../rmd-calculator/rmd-calculator.component';
import { AccountNotesComponent } from '../account-notes/account-notes.component';


@Component({
  selector: 'app-rmd-tracker',
  templateUrl: './rmd-tracker.component.html',
  styleUrls: ['./rmd-tracker.component.css'],
})
export class RmdTrackerComponent implements OnInit, OnChanges {
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid!: DxDataGridComponent;
  @ViewChild('accountNotes', { static: false }) accountNotesComponent!: AccountNotesComponent;
  windowRef = window; // Create a reference to the global window object
  cacheDate: Date | undefined;
  allRmdTrackerInheritedData: RMDAccountLevelViewModel[] = [];
  rmdTrackerInheritedDetails: RMDAccountLevelViewModel[] = [];
  allRmdTrackerNonInheritedData: RMDTrackingInvestorLevelViewModel[] = [];
  rmdTrackerNonInheritedDetails: RMDTrackingInvestorLevelViewModel[] = [];
  advisoryFirms: any[] = [];
  selFirm: any;
  selIRAType: number = 1;
  selRequirement: number = 1;
  //asOfDate: string = '';
  asOfDate: string | undefined;
  isInitializing = true;
  isAdvisorUser = false;
  isNonHQServicerUser = false;
  isReadOnlyUser = false;
  isWriteUser = false;
  isAdvisorImpersonatedByNonHQServicerUser = false;
  isAdvisorImpersonatedByReadOnlyUser = false;
  isAdvisorImpersonatedByWriteUser = false;

  visiblePopup = false;
  componentReady = false;
  user: IUser | undefined;
  selectedAccount: any = null;
  calculatorEnabled: boolean = false;
  calculatorMode: 'manual' | 'grid' = 'manual';
  isInherited: boolean = false;
  OriginalIRAOwnerDOD: Date | undefined;

  visibleNotesPopup = false;
  selectedAccounts: RMDAccountLevelViewModel[] = [];
  selectedInvestor: RMDTrackingInvestorLevelViewModel | null = null;
  @ViewChild('dgRmdTracker', { static: false }) rmdTrackerGrid!: DxDataGridComponent;
  gridColumns: Array<DataGridColumn> = [
    {
      dataField: "investorName",
      caption: "Investor Name",
      width: 135,
      allowEditing: false,
      sortIndex: 0,
      sortOrder: "asc",
      allowHeaderFiltering: true,
      fixed: true,
      fixedPosition: "left"
    },
    {
      dataField: "householdName",
      caption: "Household Name",
      width: 150,
      allowEditing: false,
      allowHeaderFiltering: true,
      fixed: true,
      fixedPosition: "left"
    },
    {
      dataField: "id",
      caption: "Our Status",
      cellTemplate: "colActions",
      width: 65,
      allowEditing: false,
      allowHeaderFiltering: false,
      allowFiltering: false,
    },
    {
      dataField: "latestNote",
      caption: "Latest Note",
      width: 340,
      allowEditing: false,
      allowHeaderFiltering: false,
      cellTemplate: (container, options) => {
        container.classList.add('pointer-cursor');
        container.textContent = options.text;
      }
    },
    {
      dataField: "totalNotesCount",
      caption: "Count",
      width: 20,
      allowEditing: false,
      allowHeaderFiltering: false,
      cellTemplate: (container, options) => {
        container.classList.add('pointer-cursor');
        container.textContent = options.text;
      }
    },
    {
      dataField: "hasInherited",
      caption: "Has Inherited?",
      width: 80,
      allowEditing: false,
      allowHeaderFiltering: true
    },
    //{ dataField: 'latestNote', caption: 'Latest Note', cellTemplate: 'latestNoteTemplate' },
    //{ dataField: 'notesCount', caption: 'Note Count', cellTemplate: 'notesCountTemplate' },
    {
      dataField: "holderAge",
      caption: "Holder Age",
      width: 70,
      allowEditing: false,
      allowHeaderFiltering: false,
    },
    {
      dataField: "currYearRMD",
      caption: "Curr Year RMD",
      format: { type: 'currency', precision: 2 },
      width: 90,
      allowEditing: false,
      allowHeaderFiltering: false,
      cellTemplate: (container, options) => {
        container.classList.add('bold-currency-cell');
        container.textContent = options.text;
      }
    },
    {
      dataField: "ytdDistribution",
      caption: "YTD Distribution",
      format: {type: 'currency', precision: 2},
      width: 90,
      allowEditing: false,
      allowHeaderFiltering: false,
    },
    {
      dataField: "remainingRMD",
      caption: "Remaining RMD",
      format: {type: 'currency', precision: 2},
      width: 90,
      allowEditing: false,
      allowHeaderFiltering: false,
    },
    {
      dataField: "cashAvailable",
      caption: "Cash Available",
      format: {type: 'currency', precision: 2},
      width: 90,
      allowEditing: false,
      allowHeaderFiltering: false,
    },
    {
      dataField: "advisorName",
      caption: "Advisor",
      width: 120,
      allowEditing: false,
      allowHeaderFiltering: true,
    },
    {
      dataField: "repIds",
      caption: "Account IP",
      width: 70,
      allowEditing: false,
      allowHeaderFiltering: false,
    },
    {
      dataField: "advisorRepNumber",
      caption: "IP",
      width: 70,
      allowEditing: false,
      allowHeaderFiltering: false,
    },
    {
      dataField: "secondaryAdvisorNames",
      caption: "Secondary Advisors",
      width: 140,
      allowEditing: false,
      allowHeaderFiltering: true,
    },
  ];

  accountGridColumns: Array<DataGridColumn> = [
    {
      dataField: 'accountName', caption: 'Account Name',
      width: 150,
      allowEditing: false
    },
    {
      dataField: 'rmdListingStatus', caption: 'Account Status',
      width: 70,
      allowEditing: false
    },
    {
      dataField: 'accountNumber', caption: 'Account Number',
      width: 85,
      allowEditing: false
    },
    {
      dataField: "latestNote", caption: "Latest Note",
      width: 100,
      allowEditing: false, allowHeaderFiltering: false,
      cellTemplate: (container, options) => {
        container.classList.add('pointer-cursor');
        container.textContent = options.text;
      }
    },
    {
      dataField: "notesCount", caption: "Count",
      width: 20,
      allowEditing: false, allowHeaderFiltering: false,
      cellTemplate: (container, options) => {
        container.classList.add('pointer-cursor');
        container.textContent = options.text;
      }
    },
    {
      dataField: 'repId', caption: 'Account IP',
      width: 60,
      allowEditing: false
    },
    {
      dataField: 'managerAndProduct', caption: 'Product Description',
      width: 100,
      allowEditing: false
    },
    //{ dataField: 'multipleRetirementAccountInd', caption: 'Mult.Accts?', allowEditing: false },
    {
      dataField: 'periodicPaymentFlag', caption: 'Periodic Pmt?',
      width: 45,
      allowEditing: false
    },
    {
      dataField: 'OriginalIRAOwnerDOD', caption: 'Orig DOD',
      width: 80,
      allowEditing: false, dataType: 'date', format: 'MM/dd/yyyy'
    },
    {
      dataField: 'checkWritingCapable', caption: 'Check Writing?',
      width: 45,
      allowEditing: false, calculateCellValue: (rowData: { checkWritingCapable: boolean }) => rowData.checkWritingCapable ? 'Yes' : 'No'
    },
    {
      dataField: 'status', caption: 'Calcd. Status',
      width: 95,
      allowEditing: false
    },
    { dataField: 'prevYearFMV', caption: 'Prev Yr. FMV', format: { type: 'currency', precision: 2 }, width: 85, allowEditing: true },
    {
      dataField: 'currYearRMD',
      caption: 'Curr Yr. RMD',
      format: { type: 'currency', precision: 2 },
      width: 85,
      allowEditing: true,
      cellTemplate: (container, options) => {
        container.classList.add('bold-currency-cell');
        container.textContent = options.text;
      }
    },
    {
      dataField: 'ytdDistribution', caption: 'YTD Distribution',
      format: { type: 'currency', precision: 2 },
      width: 90,
      allowEditing: true
    },
    {
      dataField: 'remainingRMD', caption: 'Remaining RMD',
      format: { type: 'currency', precision: 2 },
      width: 90,
      allowEditing: false
    },
    {
      dataField: 'cashAvailable', caption: 'Cash Available',
      format: { type: 'currency', precision: 2 },
      width: 90,
      allowEditing: false
    }
  ];

  @ViewChild('dgRmdInheritedTracker', { static: false }) rmdInheritedTrackerGrid!: DxDataGridComponent;
  inheritedGridColumns: Array<DataGridColumn> = [
    {
      dataField: "investorName", caption: "Investor Name",
      width: 135,
      allowEditing: false, sortIndex: 0, sortOrder: "asc", allowHeaderFiltering: true,
      fixed: true,
      fixedPosition: "left"
    },
    {
      dataField: "householdName", caption: "Household Name",
      width: 150,
      allowEditing: false, allowHeaderFiltering: true,
      fixed: true,
      fixedPosition: "left"
    },
    {
      dataField: "holderAge", caption: "Age",
      width: 35,
      allowEditing: false, allowHeaderFiltering: false
    },
    {
      dataField: "accountName", caption: "Account Name",
      width: 150,
      allowEditing: false, allowHeaderFiltering: false
    },
    {
      dataField: "id",
      caption: "Our Status",
      cellTemplate: "colInheritedActions",
      width: 65,
      allowEditing: false,
      allowHeaderFiltering: false,
    },
    {
      dataField: "latestNote", caption: "Latest Note",
      width: 100,
      allowEditing: false, allowHeaderFiltering: false,
      cellTemplate: (container, options) => {
        container.classList.add('pointer-cursor');
        container.textContent = options.text;
      }
    },
    {
      dataField: "notesCount", caption: "Count",
      width: 20,
      allowEditing: false, allowHeaderFiltering: false,
      cellTemplate: (container, options) => {
        container.classList.add('pointer-cursor');
        container.textContent = options.text;
      }
    },
    {
      dataField: "hasNonInherited", caption: "Has Non-Inherited?",
      width: 130,
      allowEditing: false, allowHeaderFiltering: true
    },
    {
      dataField: "accountNumber", caption: "Account Number",
      width: 85,
      allowEditing: false, allowHeaderFiltering: false
    },
    {
      dataField: "managerAndProduct", caption: "Product Description",
      width: 100,
      allowEditing: false, allowHeaderFiltering: false
    },
    {
      dataField: "periodicPaymentFlag", caption: "Periodic Pmt?",
      width: 100,
      allowEditing: false, allowHeaderFiltering: false
    },
    {
      dataField: 'checkWritingCapable', caption: 'Check Writing?',
      width: 110,
      allowEditing: false, calculateCellValue: (rowData: { checkWritingCapable: boolean }) => rowData.checkWritingCapable ? 'Yes' : 'No'
    },
    {
      dataField: 'doubleInheritedIRA', caption: 'Successor Inherited?',
      width: 135,
      allowEditing: true, dataType: "boolean"
    },
    {
      dataField: "status", caption: "Calcd. Status",
      width: 95,
      allowEditing: false, allowFiltering: false, allowHeaderFiltering: true
    },
    {
      dataField: "prevYearFMV", caption: "Prev Yr. FMV",
      format: { type: 'currency', precision: 2 },
      width: 85,
      allowEditing: true, allowHeaderFiltering: false
    },
    {
      dataField: "currYearRMD",
      caption: "Curr Yr. RMD",
      format: { type: 'currency', precision: 2 },
      width: 85,
      allowEditing: true,
      allowHeaderFiltering: false,
      cellTemplate: (container, options) => {
        container.classList.add('bold-currency-cell');
        container.textContent = options.text;
      }
    },
    {
      dataField: "ytdDistribution", caption: "YTD Dist.",
      format: { type: 'currency', precision: 2 },
      width: 90,
      allowEditing: true, allowHeaderFiltering: false
    },
    {
      dataField: "remainingRMD", caption: "Remain. RMD",
      format: { type: 'currency', precision: 2 },
      width: 90,
      allowEditing: false, allowHeaderFiltering: false
    },
    {
      dataField: "cashAvailable", caption: "Cash Avail.",
      format: { type: 'currency', precision: 2 },
      width: 90,
      allowEditing: false, allowHeaderFiltering: false
    },
    {
      dataField: "monthsRemaining", caption: "Mos. Remain.",
      width: 85,
      allowEditing: false, allowHeaderFiltering: true
    },
    {
      dataField: 'originalIRAOwnerDOD', caption: 'Orig DOD',
      width: 85,
      allowEditing: false, dataType: 'date', format: 'MM/dd/yyyy'
    },
    {
      dataField: "advisorName", caption: "Advisor",
      width: 120,
      allowEditing: false, allowHeaderFiltering: true
    },
    {
      dataField: 'repId', caption: 'Account IP',
      width: 60,
      allowEditing: false
    },
    {
      dataField: "advisorRepNumber", caption: "IP",
      width: 70,
      allowEditing: false, allowHeaderFiltering: false
    },
    {
      dataField: "secondaryAdvisorNames", caption: "Secondary Advisors",
      width: 140,
      allowEditing: false, allowHeaderFiltering: true
    },
  ];

  @ViewChild('calculator', { static: false }) calculatorComponent!: RmdCalculatorComponent;


  constructor(
    private rmdTrackerApi: RmdTrackerApiService,
    private servicerService: ServicerService,
    private advisorService: AdvisorService,
    private generalService: GeneralService,
    private advisoryFirmApi: AdvisoryFirmApiService,
    private identityService: IdentityService
  ) { }

  ngOnInit(): void {
    this.identityService.getUserLocal().subscribe(
      (user) => {
        this.user = user; // Assign the actual user data
        const rawRole = String(this.user?.role ?? "");
        const roles = rawRole.includes(",")
          ? rawRole.split(",").map(r => r.trim().toUpperCase())
          : [rawRole.trim().toUpperCase()];
        this.isAdvisorUser = roles.some(r =>
          ['ADVISORY', 'ADVISORY_LEAD', 'ADVISORY_ADMIN'].includes(r)
        );
        this.isNonHQServicerUser = roles.some(r =>
          ['SERVICER_OPERATIONS', 'SERVICER_LEAD', 'SERVICER_ADMIN'].includes(r)
        );
        this.isReadOnlyUser = roles.includes("READ_ONLY");
        this.isWriteUser = roles.includes("WRITE");

        const rawImpersonatedRoles = String(this.user?.impersonatedByRolesStr ?? "");
        const impersonatedByRoles = rawImpersonatedRoles.includes(",")
          ? rawImpersonatedRoles.split(",").map(r => r.trim().toUpperCase())
          : [rawImpersonatedRoles.trim().toUpperCase()];

        this.isAdvisorImpersonatedByNonHQServicerUser =
          this.user?.impersonated === true &&
          this.isAdvisorUser &&
          impersonatedByRoles.some(r =>
            ['SERVICER_OPERATIONS', 'SERVICER_LEAD', 'SERVICER_ADMIN'].includes(r)
          );
        this.isAdvisorImpersonatedByReadOnlyUser =
          this.user?.impersonated === true &&
          this.isAdvisorUser &&
          impersonatedByRoles.includes("READ_ONLY");
        this.isAdvisorImpersonatedByWriteUser =
          this.user?.impersonated === true &&
          this.isAdvisorUser &&
          impersonatedByRoles.includes("WRITE");

        //console.log("isNonHQServicerUser", this.isNonHQServicerUser);
        //console.log("isReadOnlyUser", this.isReadOnlyUser);
        //console.log("isWriteUser", this.isWriteUser);
        //console.log("isAdvisorImpersonatedByNonHQServicerUser", this.isAdvisorImpersonatedByNonHQServicerUser);
        //console.log("isAdvisorImpersonatedByReadOnlyUser", this.isAdvisorImpersonatedByReadOnlyUser);
        //console.log("isAdvisorImpersonatedByWriteUser", this.isAdvisorImpersonatedByWriteUser);

        //console.log("USER IS",this.user);
        // Load advisory firms after setting user info
        this.advisoryFirmApi.getAdvisoryFirms().subscribe(
          (response) => {
            this.advisoryFirms = response;
            this.selFirm = this.advisoryFirms[0];
            this.firmChanged();
          },
          (error) => this.generalService.showError(error)
        );
      },
      (error) => {
        this.generalService.showError(error);
      }
    );

    this.generalService.getRMDCalculatorEnabled().subscribe(
      (response) => {

        this.calculatorEnabled = response;

        if (this.calculatorEnabled) {
          this.accountGridColumns.push({
            caption: 'Actions',
            cellTemplate: 'accountCalcTemplate',
            width: 90
          });
          this.inheritedGridColumns.push({
            caption: 'Actions',
            cellTemplate: 'accountCalcTemplateInh',
            width: 90
          });
        }

      },
      (error) => this.generalService.showError(error)
    );
  }

  //oncp(event: any): void {
  //  //console.log('Cell Prepared Event:', event);
  //  if (event.row?.rowType === 'data') {
  //    const data = event.row.data;
  //    //if (data.rmdListingStatus === "Deleted Acct" && data.multipleRetirementAccountInd === "YES") {
  //    //  event.cellElement.style.color = "red";
  //    //}
  //    if (data.rmdListingStatus === "Deleted Acct") {
  //      event.cellElement.style.color = "red";
  //    }
  //    if (event.column.dataField === 'latestNote'
  //      || event.column.dataField === 'totalNotesCount'
  //      || event.column.dataField === 'notesCount') {
  //      event.cellElement.style.cursor = 'pointer';
  //    }
  //  }
  //}

  oncp(event: any): void {
    //console.log('Cell Prepared Event:', event);
    if (event.row?.rowType === 'data') {
      //const data = event.row.data;
      //const cell = event.cellElement;

      if (event.row.data.rmdListingStatus === "Deleted Acct") {
        event.cellElement.classList.add('deleted-acct');
      }
    }
  }

  canEdit(): boolean {
    return (
      ((this.isNonHQServicerUser || this.isWriteUser) && !this.isReadOnlyUser)
      || ((this.isAdvisorImpersonatedByNonHQServicerUser || this.isAdvisorImpersonatedByWriteUser) && !this.isAdvisorImpersonatedByReadOnlyUser)
    );
  }

  onep(event: any): void {
    //console.log('Editor Preparing Event:', event);

    if (event.row?.rowType === 'data') {
      const data = event.row.data;

      if (
        !this.canEdit()
        || (data.custodianProvidedData && ['prevYearFMV', 'currYearRMD', 'ytdDistribution'].includes(event.dataField))) {
        event.editorOptions.disabled = true;
      }

      if (
        !this.canEdit()
        || (event.dataField === 'accountRmdStatus.notes' && !data.accountId)) {
        event.editorOptions.disabled = true;
      }
    }
  }

  onru(event: any, inherited: boolean = false): void {
    //console.log('Row Updating Event:', event);

    // Ensure only authorized users can update
    if (!this.canEdit())
      return;

    const { oldData, newData, key } = event;
    let { prevYearFMV, currYearRMD, ytdDistribution, remainingRMD } = oldData;

    // Update values based on new data
    if (newData.prevYearFMV !== undefined) prevYearFMV = newData.prevYearFMV;
    if (newData.currYearRMD !== undefined) currYearRMD = newData.currYearRMD;
    if (newData.ytdDistribution !== undefined) ytdDistribution = newData.ytdDistribution;

    // Calculate remaining RMD
    // GL - fixed 7/1/2025
    //remainingRMD = currYearRMD && ytdDistribution ? currYearRMD - ytdDistribution : null;
    if (currYearRMD != null) {
      remainingRMD = (Number(currYearRMD) || 0) - (Number(ytdDistribution) || 0);
    } else {
      remainingRMD = null;
    }
    //console.log("REMAINING RMD IS", remainingRMD);

    // Initialize accountRmdStatus or update existing
    let acctRmdStatus = oldData.accountRmdStatus ? { ...oldData.accountRmdStatus } : {
      id: 0,
      accountId: oldData.accountId,
      year: +oldData.asOfDate.substring(6, 10),
      prevYearFMV: null,
      currYearRMD: null,
      ytdDistribution: null,
      remainingRMD: null,
      status: null,
      notes: '',
      doubleInheritedIRA: false
    };

    acctRmdStatus = {
      ...acctRmdStatus,
      prevYearFMV,
      currYearRMD,
      ytdDistribution,
      remainingRMD,
      status: newData.accountRmdStatus?.status ?? oldData.accountRmdStatus?.status ?? '',
      notes: newData.accountRmdStatus?.notes ?? oldData.accountRmdStatus?.notes ?? '',
      doubleInheritedIRA: newData.doubleInheritedIRA ?? oldData.doubleInheritedIRA ?? ''
    };

    // Update the specific row's data with the new remaining RMD
    //if (remainingRMD != null) - GL 7/1/2025 commented out this conditional
    event.oldData.remainingRMD = remainingRMD;

    // Update the backend via service
    this.updateAccountRMDStatus(acctRmdStatus, inherited);

    // Update master record for non-inherited data
    if (!inherited) {
      const masterRecord = this.allRmdTrackerNonInheritedData.find(investor =>
        investor.accounts?.some(account => account.accountId === key)
      );
      if (masterRecord) {
        let changeInCYR = 0;
        let changeInYTDD = 0;

        if (newData.hasOwnProperty('prevYearFMV')) {
          changeInCYR = currYearRMD - (oldData.currYearRMD || 0);
          masterRecord.currYearRMD = (masterRecord.currYearRMD || 0) + changeInCYR;
        } else if (newData.hasOwnProperty('currYearRMD')) {
          changeInCYR = currYearRMD - oldData.currYearRMD;
          masterRecord.currYearRMD = (masterRecord.currYearRMD || 0) + changeInCYR;
        }

        if (newData.hasOwnProperty('ytdDistribution')) {
          changeInYTDD = ytdDistribution - oldData.ytdDistribution;
          masterRecord.ytdDistribution = (masterRecord.ytdDistribution || 0) + changeInYTDD;
        }

        masterRecord.remainingRMD = (masterRecord.currYearRMD || 0) - (masterRecord.ytdDistribution || 0);
      }

      //this.refreshGrid(this.rmdTrackerGrid);
      const rowIndex = this.rmdTrackerGrid.instance.getRowIndexByKey(oldData.accountId);
      if (rowIndex !== -1) {
        this.rmdTrackerGrid.instance.repaintRows([rowIndex]);
      }
    } else {

    }
  }

  onUpdate(event: any): void {

    // Ensure only authorized users can update
    if (!this.canEdit())
      return;

    let invRmdStatus = event.oldData.investorRmdStatus;

    if (!invRmdStatus) {
      const year = event.oldData.asOfDate?.substring(6, 10);
      invRmdStatus = {

        id: 0,
        advisoryFirmId: event.oldData.advisoryFirmId,
        investorId: event.oldData.investorId,
        inheritedFlag: event.oldData.inheritedFlag,
        year: +year, // Convert string year to number
        status: RmdStatus.UNMET, // Default status
        notes: event.newData.investorRmdStatus.notes,
      };
    } else {
      invRmdStatus = {
        ...invRmdStatus,
        notes: event.newData.investorRmdStatus.notes,
      };
    }

    this.updateInvestorRMDStatus(event, invRmdStatus);
  }

  changeNonInheritedRequirementMetStatus(item: any, requirementMet: boolean): void {

    // Ensure only authorized users can update
    if (!this.canEdit())
      return;

    let invRmdStatus: InvestorRmdStatusViewModel;

    if (!item.investorRmdStatus) {
      const year = parseInt(item.asOfDate.substring(6, 10), 10);
      invRmdStatus = {
        id: 0,
        advisoryFirmId: item.advisoryFirmId,
        inheritedFlag: item.inheritedFlag,
        investorId: item.investorId,
        notes: "",
        status: requirementMet ? RmdStatus.MET : RmdStatus.UNMET,
        year: year,
      };
    } else {
      invRmdStatus = {
        ...item.investorRmdStatus,
        status: requirementMet ? RmdStatus.MET : RmdStatus.UNMET
      };
    }

    this.rmdTrackerApi.updateInvestorRMDStatus(invRmdStatus).subscribe(
      (updatedStatus) => {
        item.investorRmdStatus = updatedStatus;
        this.refreshGrid(this.rmdTrackerGrid);
        this.generalService.showSuccess("Investor RMD status has been updated.");
      },
      (error) => this.generalService.showError(error)
    );
  }

  changeInheritedRequirementMetStatus(item: any, requirementMet: boolean): void {

    // Ensure only authorized users can update
    if (!this.canEdit())
      return;

    const year = parseInt(item.asOfDate.substring(6, 10), 10); // Extract year
    const acctRmdStatus: AccountRmdStatusViewModel = item.accountRmdStatus
      ? {
        ...item.accountRmdStatus,
        status: requirementMet ? RmdStatus.MET : RmdStatus.UNMET,
      }
      : {
        id: 0,
        accountId: item.accountId,
        prevYearFMV: null,
        currYearRMD: null,
        ytdDistribution: null,
        remainingRMD: null,
        notes: "",
        status: requirementMet ? RmdStatus.MET : RmdStatus.UNMET,
        year,
      };

    this.rmdTrackerApi.updateAccountRMDStatus(this.selFirm.id, acctRmdStatus).subscribe(
      (updatedStatus) => {
        // Update the local data model
        item.accountRmdStatus = updatedStatus;

        // Refresh the associated grid
        this.refreshGrid(this.rmdInheritedTrackerGrid);

        // Notify the user
        this.generalService.showSuccess("Account RMD status has been updated.");
      },
      (error) => this.generalService.showError(error)
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle input property changes if necessary
  }

  // Function to refresh cache and reload data
  refreshCache() {
    this.allRmdTrackerInheritedData = [];
    this.allRmdTrackerNonInheritedData = [];

    this.loadRMDTracker(true);

    //console.log("Refreshing cache...");
  }

  isAOUser(): boolean {
    return this.user?.username == "00000001"
  }

  loadRMDTracker(clearCache: boolean = false): void {
    if (!this.selFirm?.id) return;

    this.isInitializing = true;
    this.asOfDate = undefined;
    this.cacheDate = undefined;

    const adminMode = this.isAdvisorUser ? this.advisorService.getAdminMode()?.enabled : false;

    const adminModeSafe = typeof adminMode === 'boolean' ? adminMode : false;
    this.rmdTrackerApi.getFreshCompressedRMDTrackingData(adminModeSafe, this.selFirm.id, this.user, clearCache).subscribe(
      (response: any) => {
        this.cacheDate = response?.cacheDate;
        this.allRmdTrackerInheritedData = response?.inherited || [];
        this.allRmdTrackerNonInheritedData = response?.nonInherited || [];
        this.filterChanged();
        this.isInitializing = false;
      },
      (error) => {
        this.isInitializing = false;
        this.generalService.showError(error);
      }
    );
  }

  firmChanged(): void {
    this.loadRMDTracker();
  }

  filterChanged(): void {
    //console.log('Filter Changed:', {
    //  selIRAType: this.selIRAType,
    //  selRequirement: this.selRequirement,
    //});

    if (this.allRmdTrackerNonInheritedData.length > 0) {
      this.asOfDate = this.allRmdTrackerNonInheritedData[0]?.asOfDate || '';
      this.rmdTrackerNonInheritedDetails =
        this.selRequirement === 1
          ? this.allRmdTrackerNonInheritedData
          : this.selRequirement === 2
            ? this.allRmdTrackerNonInheritedData.filter((item) => !item.investorRmdStatus || item.investorRmdStatus.status === RmdStatus.UNMET)
            : this.allRmdTrackerNonInheritedData.filter((item) => item.investorRmdStatus?.status === RmdStatus.MET);
    }

    if (this.allRmdTrackerInheritedData.length > 0) {
      this.rmdTrackerInheritedDetails =
        this.selRequirement === 1
          ? this.allRmdTrackerInheritedData
          : this.selRequirement === 2
            ? this.allRmdTrackerInheritedData.filter((item) => !item.accountRmdStatus || item.accountRmdStatus.status === RmdStatus.UNMET)
            : this.allRmdTrackerInheritedData.filter((item) => item.accountRmdStatus?.status === RmdStatus.MET);
    }
  }

  updateInvestorRMDStatus(event: any, invRmdStatus: any): void {

    // Ensure only authorized users can update
    if (!this.canEdit())
      return;

    this.rmdTrackerApi.updateInvestorRMDStatus(invRmdStatus).subscribe(
      (updatedStatus) => {
        // Update the specific row's data with the new status
        event.oldData.investorRmdStatus = updatedStatus;

        this.refreshGrid(this.rmdTrackerGrid);

        // Provide user feedback
        this.generalService.showSuccess("Investor RMD data has been updated.");
      },
      (error) => {
        // Handle API errors
        this.generalService.showError(error);
      }
    );
  }

  updateAccountRMDStatus(acctRmdStatus: any, inherited: boolean): void {

    // Ensure only authorized users can update
    if (!this.canEdit())
      return;

    //console.log("UPDATING DATABASE", acctRmdStatus, "IN",inherited);

    this.rmdTrackerApi.updateAccountRMDStatus(this.selFirm.id, acctRmdStatus).subscribe(
      (updatedStatus) => {
        if (inherited) {
          const record = this.allRmdTrackerInheritedData.find((item) => item.accountId === updatedStatus.accountId);
          if (record) {
            //console.log("UPDATED STATUS IS", updatedStatus);
            //console.log("RECORD IS", record);

            // Update the existing record with the new updatedStatus
            //Object.assign(record, updatedStatus);
            record.status =
              updatedStatus.currYearRMD != null && updatedStatus.ytdDistribution != null
                ? updatedStatus.currYearRMD - updatedStatus.ytdDistribution <= 0
                  ? "MET"
                  : "NOT MET"
                : "";

            //console.log("UPDATED accountRmdStatus IS", updatedStatus);
            // Ensure accountRmdStatus in the record has the updated ID
            record.accountRmdStatus = updatedStatus; // Important: Assign the updatedStatus to accountRmdStatus
            //this.refreshGrid(this.rmdInheritedTrackerGrid);
          }
        } else {
          let cnt = 0;
          this.allRmdTrackerNonInheritedData.forEach((f) => {
            const account = f.accounts.find((a) => a.accountId === updatedStatus.accountId);
            if (account) {
              cnt = cnt + 1;
              // Update the existing account with the new updatedStatus
              //Object.assign(account, updatedStatus);
              account.status =
                updatedStatus.currYearRMD != null && updatedStatus.ytdDistribution != null
                  ? updatedStatus.currYearRMD - updatedStatus.ytdDistribution <= 0
                    ? "MET"
                    : "NOT MET"
                  : "";
              // Ensure accountRmdStatus in the account has the updated ID
              account.accountRmdStatus = updatedStatus; // Important: Assign the updatedStatus to accountRmdStatus
            }
          });
          //if (cnt > 0) {
          //  this.refreshGrid(this.rmdTrackerGrid);
          //}
        }

        this.generalService.showSuccess("Account RMD data has been updated.");
      },
      (error) => this.generalService.showError(error)
    );
  }

  refreshGrid(gridComponent: DxDataGridComponent): void {
    if (gridComponent && gridComponent.instance) {
      gridComponent.instance.refresh().then(() => {
        //console.log('Grid refreshed successfully.');
      }).catch((error) => {
        console.error('Error refreshing grid:', error);
      });
    } else {
      console.warn('Grid component instance is not available.');
    }
  }

  // showCalculator(account: any = null, inherited: boolean = false): void {
  //   this.selectedAccount = account; // ? { ...account } : null;
  //   this.calculatorMode = account ? 'grid' : 'manual';
  //   this.isInherited = inherited;
  //   this.visiblePopup = true;
  // }

  showCalculator(account: any = null, inherited: boolean = false): void {
    this.componentReady = false;

    this.isInherited = inherited;
    this.calculatorMode = account ? 'grid' : 'manual';

    if (account && !inherited) {
      // Find updated account reference from your main data model
      const investor = this.allRmdTrackerNonInheritedData.find(i =>
        i.accounts.some(a => a.accountId === account.accountId)
      );

      if (investor) {
        this.selectedAccount = investor.accounts.find(a => a.accountId === account.accountId);
      }
    } else if (account && inherited) {
      // For inherited grid, it's flat — find directly
      this.selectedAccount = this.allRmdTrackerInheritedData.find(a =>
        a.accountId === account.accountId
      );
    } else {
      this.selectedAccount = null;
    }

    setTimeout(() => {
      this.componentReady = true;
      this.visiblePopup = true;
    });
  }

  onSaveFromCalculator(payload: { updatedData: any, isInherited: boolean }): void {
    const { updatedData, isInherited } = payload;

    //console.log("CALCULATOR SAVE CALLBACK", "UD", updatedData, "II", isInherited);

    if (!updatedData || !updatedData.accountId) return;

    if (!isInherited) {
      // Find the matching account in the data model and update it
      this.allRmdTrackerNonInheritedData.forEach(investor => {
        const acct = investor.accounts.find(acc => acc.accountId === updatedData.accountId);
        if (acct) {
          acct.prevYearFMV = Number(updatedData.prevYearFMV);
          acct.currYearRMD = Number(updatedData.currYearRMD);
          acct.remainingRMD = Number(updatedData.remainingRMD);
          acct.accountRmdStatus = updatedData.accountRmdStatus;
        }
      });
    } else {
      // Find the matching account in the data model and update it
      const acct = this.allRmdTrackerInheritedData.find(acc => acc.accountId == updatedData.accountId);
      if (acct) {
        acct.prevYearFMV = Number(updatedData.prevYearFMV);
        acct.currYearRMD = Number(updatedData.currYearRMD);
        acct.remainingRMD = Number(updatedData.remainingRMD);
        acct.accountRmdStatus = updatedData.accountRmdStatus;
      }
    }

    // Update the DB
    this.updateAccountRMDStatus(updatedData.accountRmdStatus, isInherited);

    // Update master record for non-inherited data
    if (!isInherited) {

      const masterRecord = this.allRmdTrackerNonInheritedData.find(f => f.investorId === updatedData.investorId);
      if (masterRecord) {
        const childAccounts = masterRecord.accounts;

        masterRecord.currYearRMD = childAccounts.reduce((sum, account) => {
          return sum + (account.currYearRMD || 0);
        }, 0);

        masterRecord.ytdDistribution = childAccounts.reduce((sum, account) => {
          return sum + (account.ytdDistribution || 0);
        }, 0);

        masterRecord.remainingRMD = (masterRecord.currYearRMD || 0) - (masterRecord.ytdDistribution || 0);
      }

      this.refreshGrid(this.rmdTrackerGrid);

    } else {
      this.refreshGrid(this.rmdInheritedTrackerGrid);
      const rowIndex = this.rmdInheritedTrackerGrid.instance.getRowIndexByKey(updatedData.accountId);
      if (rowIndex !== -1) {
        this.rmdInheritedTrackerGrid.instance.repaintRows([rowIndex]);
      }
    }

    // Reset the calculator and close the popup.
    if (this.calculatorComponent) {
      this.calculatorComponent.reset();
    }
    this.visiblePopup = false;

  }

  onPopupShown(): void {
    //console.log('Popup shown');
  }

  onPopupHidden(): void {
    //console.log('Popup hidden');
    this.visiblePopup = false;
    this.componentReady = false;
  }

  onConfirm(): void {
    //console.log('Confirm button clicked');
    this.visiblePopup = false;
  }

  onCancel(): void {
    //console.log('Cancel button clicked');
    this.visiblePopup = false;
  }

  isFilterCondition(obj: any): obj is FilterCondition {
    return obj && typeof obj.columnIndex === "number";
  }
  // Excel Export Code
  parseFilterStructure(filter: any, columnsHeaders: (string | undefined)[]): string {
    if (!Array.isArray(filter)) {
      return ""
    }

    if (this.isFilterCondition(filter)) {
      const colIndex = filter.columnIndex;
      const colCaption = columnsHeaders[colIndex];
      const operation = filter.selectedFilterOperation || "??";
      const value = filter.filterValue ?? "";

      return `${colCaption} ${operation} ${value}`;
    }

    const resultParts: string[] = [];

    for (let i = 0; i < filter.length; i++) {
      const item = filter[i];

      if (typeof item === 'string') {
        // Likely "and" or "or" operator
        // Convert to uppercase or keep as is
        if (item.toLowerCase() === "and" || item.toLowerCase() === "or") {
          resultParts.push(item.toUpperCase());
        } else {
          // If it's just some other string, append it
          resultParts.push(item);
        }
      } else {
        // Nested array or object; recurse
        const subStr = this.parseFilterStructure(item, columnsHeaders);
        resultParts.push(subStr);
      }
    }
    // Join them all together with spaces.
    // If there's more than one element, we wrap in parentheses to clarify grouping.
    const joined = resultParts.join(" ");
    if (resultParts.length > 1) {
      return `(${joined})`;
    } else {
      return joined;
    }
  }
  // 📌 This method is triggered when the DevExtreme export event is fired
  async onExporting(e: DxDataGridTypes.ExportingEvent) {
    const workbook = new Workbook();
    const sheetMasterDetail = workbook.addWorksheet('Master-Detail');
    const sheetMasterOnly = workbook.addWorksheet('Master Data');
    const sheetDetailOnly = workbook.addWorksheet('Detail Data');

    const dataGridInstance = this.dataGrid.instance;
    const dataSource = dataGridInstance.getDataSource();
    const dataFilters = dataGridInstance.getCombinedFilter();
    const loadOptions = dataSource.loadOptions();
    const dataStore = dataSource.store();

    //console.log('DataGrid Load Options:', loadOptions);
    //console.log('DataGrid Filters:', dataFilters);

    // Load all master rows **with the active filters applied**
    const masterDataResult = await dataStore.load({
      filter: dataFilters, // Apply active filters if any
      sort: loadOptions.sort,
    }) as any; // Explicitly typing as `any` to prevent TypeScript issues

    // Ensure the result is always an array
    const masterData: any[] = Array.isArray(masterDataResult)
      ? masterDataResult
      : (masterDataResult.data && Array.isArray(masterDataResult.data))
        ? masterDataResult.data
        : [];

    // Get visible columns for master rows
    const masterColumns = dataGridInstance.getVisibleColumns().filter(col => col.type != 'detailExpand');
    const masterHeader = masterColumns.map(col => col.caption || col.dataField);

    var filterText = this.parseFilterStructure(dataFilters, masterHeader);

    // ========================== SHEET 1: MASTER-DETAIL VIEW ==========================
    sheetMasterDetail.addRow(['Master-Detail Data']).font = { bold: true, size: 14 };
    sheetMasterDetail.addRow([]); // Blank Row
    const filterRow = sheetMasterDetail.addRow(['Filters Applied:', filterText]);
    filterRow.font = { bold: true };
    filterRow.eachCell((cell, columnNumber) => {
      if (columnNumber > 1) {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } };
      }

    })
    sheetMasterDetail.mergeCells(filterRow.number, 2, filterRow.number, masterHeader.length + 1);
    sheetMasterDetail.addRow([]); // Blank Row

    // Add Master Row Headers
    sheetMasterDetail.addRow(['', 'Investor ID', ...masterHeader]).eachCell(cell => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
    });

    let rowIndex = 3;
    for (const master of masterData) {
      // 📌 Add Master Row
      const masterRow = sheetMasterDetail.addRow(
        ['', master.investorId, ...masterColumns.map(col => col.dataField ? master[col.dataField] : '')]
      );
      masterRow.eachCell(cell => cell.font = { bold: true });

      const detailsData = master.accounts;

      if (detailsData.length > 0) {
        // 📌 Add Investor Name Header for Details
        const investorHeader = sheetMasterDetail.addRow([
          '', '', `${master.investorName}: Account(s)`
        ]);

        // Merge investor name row across all detail columns
        sheetMasterDetail.mergeCells(
          investorHeader.number,
          3, // Column C (first detail column)
          investorHeader.number,
          3 + this.accountGridColumns.length // Last detail column
        );

        // Style merged header row
        investorHeader.eachCell((cell, colNumber) => {
          if (colNumber >= 3) {
            cell.font = { bold: true, size: 12 };
            cell.alignment = { horizontal: 'left', vertical: 'bottom' };
          }
        });
        investorHeader.height = 35; // Triple the height

        // 📌 Add Detail Row Headers
        const detailHeaderRow = sheetMasterDetail.addRow([
          '', '', ...this.accountGridColumns.map(col => col.caption)
        ]);
        detailHeaderRow.eachCell((cell, colNumber) => {
          if (colNumber >= 3) {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            // client asked for no fill color on the detail header row
            //cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFDDEBF7' } }; // Light blue
          }
        });

        // 📌 Add Detail Rows (Background for entire detail grid)
        for (const detail of detailsData) {
          const detailRow = sheetMasterDetail.addRow([
            '', '',
            ...this.accountGridColumns.map(col => col.dataField ? detail[col.dataField] ?? '' : '')
          ]);
          detailRow.eachCell((cell, colNumber) => {
            if (colNumber >= 3) {
              cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFDDEBF7' } }; // Light blue
            }
          });
        }
      }

      sheetMasterDetail.addRow([]); // Space Before Next Master Row
    }

    // ========================== SHEET 2: MASTER ONLY ==========================
    sheetMasterOnly.addRow(['Master Data']).font = { bold: true, size: 14 };
    sheetMasterOnly.addRow([]); // Blank Row
    sheetMasterOnly.addRow(['', 'Investor ID', ...masterColumns.map(col => col.caption || col.dataField)]).eachCell(cell => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
    });

    for (const master of masterData) {
      sheetMasterOnly.addRow(['', master.investorId, ...
        masterColumns.map(col => col.dataField ? master[col.dataField] : '')]
      );
    }

    // ========================== SHEET 3: DETAIL ONLY ==========================
    sheetDetailOnly.addRow(['Detail Data']).font = { bold: true, size: 14 };
    sheetDetailOnly.addRow([]); // Blank Row

    // Use accountGridColumns for header row, starting at Column B
    const detailHeader = ['', 'Investor ID', 'Investor Name', ...this.accountGridColumns.map(col => col.caption)];
    sheetDetailOnly.addRow(detailHeader).eachCell((cell, colNumber) => {
      if (colNumber >= 2) { // Start styling from Column B
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center' };
      }
    });

    for (const master of masterData) {
      const detailsData = master.accounts;
      for (const detail of detailsData) {
        sheetDetailOnly.addRow([
          '', // Empty Column A
          master.investorId, // Column B
          master.investorName, // Column C
          ...this.accountGridColumns.map(col => col.dataField ? detail[col.dataField] ?? '' : '') // Account details
        ]);
      }
    }

    // ========================== EXPORT FILE ==========================
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(blob, `RMD_Data_${new Date().toISOString().split('T')[0]}.xlsx`);
  }
  async onExportingInherited(e: DxDataGridTypes.ExportingEvent) {
    const workbook = new Workbook();
    const sheetDetailOnly = workbook.addWorksheet('Detail Data');

    const dataGridInstance = this.dataGrid.instance;
    const dataSource = dataGridInstance.getDataSource();
    const dataFilters = dataGridInstance.getCombinedFilter();
    const loadOptions = dataSource.loadOptions();
    const dataStore = dataSource.store();

    //console.log('DataGrid Load Options:', loadOptions);
    //console.log('DataGrid Filters:', dataFilters);

    // Load all master rows **with the active filters applied**
    const masterDataResult = await dataStore.load({
      filter: dataFilters, // Apply active filters if any
      sort: loadOptions.sort,
    }) as any; // Explicitly typing as `any` to prevent TypeScript issues

    // Ensure the result is always an array
    const masterData: any[] = Array.isArray(masterDataResult)
      ? masterDataResult
      : (masterDataResult.data && Array.isArray(masterDataResult.data))
        ? masterDataResult.data
        : [];

    // Get visible columns for master rows
    const masterColumns = dataGridInstance.getVisibleColumns();
    const masterHeader = masterColumns.map(col => col.caption || col.dataField);

    var filterText = this.parseFilterStructure(dataFilters, masterHeader);

    sheetDetailOnly.addRow(['Detail Data']).font = { bold: true, size: 14 };
    sheetDetailOnly.addRow([]); // Blank Row

    const filterRow = sheetDetailOnly.addRow(['Filters Applied:', filterText]);
    filterRow.font = { bold: true };
    filterRow.eachCell((cell, columnNumber) => {
      if (columnNumber > 1) {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } };
      }

    })
    sheetDetailOnly.mergeCells(filterRow.number, 2, filterRow.number, masterHeader.length + 6);
    sheetDetailOnly.addRow([]); // Blank Row

    sheetDetailOnly.addRow(['', 'Investor ID', ...masterHeader]).eachCell(cell => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
    });

    for (const detail of masterData) {
      sheetDetailOnly.addRow([
        '', // Empty Column A
        detail.investorId, // Column B
        ...this.inheritedGridColumns.map(col => col.dataField ? detail[col.dataField] ?? '' : '') // Account details
      ]);
    }

    // ========================== EXPORT FILE ==========================
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(blob, `RMD_Data_Inherited${new Date().toISOString().split('T')[0]}.xlsx`);
  }

  // Show notes in a popup
  isRMDTrackingInvestorLevelViewModel(obj: any): obj is RMDTrackingInvestorLevelViewModel {
    let ret = true;

    ret &&= typeof obj === 'object' && obj !== null;
    ret &&= typeof obj.advisoryFirmId === 'number';
    ret &&= typeof obj.investorId === 'number';
    ret &&= typeof obj.investorName === 'string';
    //ret &&= Array.isArray(obj.advisorIds);
    ret &&= typeof obj.totalNotesCount === 'number';
    ret &&= Array.isArray(obj.accounts);

    return ret;
  }

  openNotesPopup(event: any) {
    //console.log('Open Notes Popup:', event);
    if (event.rowType !== 'data') return;
    if (this.selIRAType == 1) {
      if (this.isRMDTrackingInvestorLevelViewModel(event.data)) {
        if (event.columnIndex == 4 || event.columnIndex == 5) {
          this.selectedAccounts = event.data.accounts;
          this.selectedInvestor = event.data; // Save the reference to the selected investor
          this.visibleNotesPopup = true;
        }
      }
      else if (event.columnIndex == 3 || event.columnIndex == 4) {
        this.selectedAccounts = [event.data];
        // Step 1: Traverse up the DOM to find the master detail row
        const detailRow = event.event?.currentTarget?.closest('.dx-master-detail-row');
        if (!detailRow) return;

        // Step 2: Find the previous sibling which is the master row
        const masterRow = detailRow.previousElementSibling;
        const rowIndex = masterRow?.getAttribute('aria-rowindex');

        if (rowIndex !== null && rowIndex !== undefined) {
          this.selectedInvestor = this.rmdTrackerGrid.instance.getDataSource().items()[+rowIndex - 1];
          //console.log('Parent Master Row Data:', this.selectedInvestor);
        }
        this.visibleNotesPopup = true;
      }
      else {
        this.selectedInvestor = null;
      }

    }
    else {
      if (event.columnIndex == 5 || event.columnIndex == 6) {
        this.selectedAccounts = [event.data];
        this.visibleNotesPopup = true;
      }
    }
    //if (this.visibleNotesPopup) {
    //  this.accountNotesComponent.notesUpdated.subscribe((updatedNotes) => this.onNotesUpdated(updatedNotes));
    //}
    //if (this.accountNotesComponent) {
    //  this.accountNotesComponent.refreshData();
    //}

  }

  onNotesPopupHidden() {
    this.visibleNotesPopup = false;
    this.accountNotesComponent.cleanUpOnHidden();
    if (this.selIRAType == 1)
      this.refreshGrid(this.rmdTrackerGrid);
    else
      this.refreshGrid(this.rmdInheritedTrackerGrid);
    //this.accountNotesComponent.notesUpdated.unsubscribe();
    this.selectedAccounts = [];
    this.selectedInvestor = null;
  }

  onNoteAdded(addedNote: NoteViewModel): void {
    // Refresh the grid
    if (this.selIRAType == 1 && this.selectedInvestor) {
      this.selectedInvestor.latestNote = addedNote.notes;
      this.selectedInvestor.totalNotesCount++;
      this.refreshGrid(this.rmdTrackerGrid);
    } else {
      this.refreshGrid(this.rmdInheritedTrackerGrid);
    }
  }

  onNoteDeleted(latestNote: string, incrementValue: number): void {
    // Refresh the grid
    if (this.selIRAType == 1 && this.selectedInvestor) {
      this.selectedInvestor.latestNote = latestNote;
      this.selectedInvestor.totalNotesCount += incrementValue;
      this.refreshGrid(this.rmdTrackerGrid);
    } else {
      this.refreshGrid(this.rmdInheritedTrackerGrid);
    }
  }
}
